var DOC = document;

var CORE = {

	className: 'brtn-header--main__nav__mega-menu__item--catalog',

	elements: null,

	menu: function (el) {

		var _CORE = {

			className: 'brtn-header--main__nav__dropdown--catalog',

			elements: null,

			isOpened: false,

			close: {
				className: 'brtn-header--main__nav__dropdown__close',

				elements: null,

				construct: function () {

					var elements = el.getElementsByClassName(_CORE.close.className);
					var i = 0;

					if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
						return;
					}
					_CORE.close.elements = [];

					for (i; i < elements.length; i++){
						_CORE.close.elements[_CORE.close.elements.length] = elements[i];
						elements[i].addEventListener('click', _CORE.button.onClick);

					}
				}

			},

			/**	Permet de ouvrir/ fermer le menu catalogue
			 *
			 */
			button: {
				className: 'brtn-header--main__nav__mega-menu__btn',

				elements: null,

				onClick: function (e) {
					var buttons = _CORE.button.elements;
					var $buttons = $(buttons);
					var $this = $(this);
					var elements = _CORE.elements;
					var $elements;

					e.preventDefault();

					if (elements == null ) {
						return;
					}
					$elements = $(elements);

					$elements.removeClass(_CORE.className + '--open');
					$buttons.removeClass(_CORE.button.className + '--open');


					if (_CORE.isOpened || $this.hasClass(_CORE.close.className)) {
						_CORE.isOpened = false;
						return;
					}
					$elements.addClass(_CORE.className + '--open');
					$this.addClass(_CORE.button.className + '--open');
					_CORE.isOpened = true;

				},

				construct: function() {
					var elements = el.getElementsByClassName(_CORE.button.className);
					var i = 0;

					if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
						return;
					}
					_CORE.button.elements = [];

					for (i; i < elements.length; i++){
						_CORE.button.elements[_CORE.button.elements.length] = elements[i];
						elements[i].addEventListener('click', _CORE.button.onClick);

					}

				}
			},

			/**
			 *
			 * @returns
			 */
			panel: {
				className: 'brtn-header--main__nav__dropdown__panel',

				elements: null,

				toggleParent: function (pid, back) {
					var items = _CORE.item.elements;
					var a = 0;
					var item, ipid, $item;

					if (typeof pid !== 'number' || pid <= 0 || items == null ) {
						return;
					}
					back = typeof back === 'boolean' ? back : false;

					for (a; a < items.length; a++){
						item = items[a];

						if (typeof item.dataset !== 'object' || !('id' in item.dataset)) {
							continue;
						}
						ipid = parseInt(item.dataset.id);

						if (ipid <= 0) {
							continue;
						}

						if (ipid == pid) {
							$item = $(item);

							if (!back) {
								$item.addClass(_CORE.item.className + '--active');
							}
							$item.parents('.' + _CORE.panel.className).addClass(_CORE.panel.className + '--active');

							if (('parent' in item.dataset)) {
								_CORE.panel.toggleParent(parseInt(item.dataset.parent), back);
							}
							break;
						}

					}

				},

				toggleChild: function (pid) {
					var panels = _CORE.panel.elements;
					var a = 0;
					var panel, ipid;

					if (typeof pid !== 'number' || pid <= 0 || panels == null ) {
						return;
					}

					for (a; a < panels.length; a++){
						panel = panels[a];

						if (typeof panel.dataset !== 'object' || !('panel' in panel.dataset)) {
							continue;
						}
						ipid = parseInt(panel.dataset.panel);

						if (ipid <= 0) {
							continue;
						}

						if (ipid == pid) {
							$(panel).addClass(_CORE.panel.className + '--active');
							break;
						}

					}

				},

				construct: function() {
					var elements = el.getElementsByClassName(_CORE.panel.className);
					var i = 0;

					if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
						return;
					}
					_CORE.panel.elements = [];

					for (i; i < elements.length; i++){
						_CORE.panel.elements[_CORE.panel.elements.length] = elements[i];

					}

				}

			},

			item: {
				className: 'brtn-header--main__nav__dropdown__panel__item',

				elements: null,

				onClick: function (e) {
					var $this = $(this);
					var panels = _CORE.panel.elements;
					var items = _CORE.item.elements;
					var panel = 0;
					var parent = 0;

					var hasChildren = $this.hasClass(_CORE.item.className + '--has-children');
					var isBackBtn = $this.hasClass(_CORE.item.className + '--back');

					if (!hasChildren && !isBackBtn) {
						return;
					}

					e.preventDefault();

					$(panels).removeClass(_CORE.panel.className + '--active');
					$(items).removeClass(_CORE.item.className + '--active');

					if (typeof this.dataset !== 'object') {
						return;
					}

					if( ('parent' in this.dataset) ) {
						parent = parseInt(this.dataset.parent);

						if (parent > 0) {
							_CORE.panel.toggleParent(parent, isBackBtn);
						}
					}

					if( ('id' in this.dataset) ) {
						panel = parseInt(this.dataset.id);

						if (panel > 0) {
							_CORE.panel.toggleChild(panel);
						}
					}

					if (isBackBtn) {
						return;
					}
					$this.addClass(_CORE.item.className + '--active').parents('.'+_CORE.panel.className).addClass(_CORE.panel.className + '--active');

				},

				construct: function() {
					var elements = el.getElementsByClassName(_CORE.item.className);
					var i = 0;

					if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
						return;
					}
					_CORE.item.elements = [];

					for (i; i < elements.length; i++){
						_CORE.item.elements[_CORE.item.elements.length] = elements[i];
						elements[i].addEventListener('click', _CORE.item.onClick);

					}

				}

			},

			construct: function () {
				var elements = el.getElementsByClassName(_CORE.className);
				var i = 0;

				if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
					return;
				}
				_CORE.elements = [];

				for (i; i < elements.length; i++){
					_CORE.elements[_CORE.elements.length] = elements[i];

				}
				_CORE.button.construct();
				_CORE.close.construct();
				_CORE.panel.construct();
				_CORE.item.construct();


			}

		};
		_CORE.construct();

	},

	construct: function () {
		var elements = DOC.getElementsByClassName(CORE.className);
		var i = 0;

		if (elements == null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
			return;
		}
		CORE.elements = [];

		for (i; i < elements.length; i++){
			CORE.elements[CORE.elements.length] = elements[i];
			CORE.menu(elements[i]);
		}

	}

};

export default CORE.construct;